
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-resizer",
      function () {
        return require("private-next-pages/image-resizer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-resizer"])
      });
    }
  